import Repository from '@/libs/axios'

const multilingualSettingsResource = '/admin/settings/multilingual-setting'

export default {
  getMultilingualSettings(section) {
    return Repository.get(`${multilingualSettingsResource}`, {
      data: { section },
    })
  },
  updateMultilingualSettings(section, payload) {
    return Repository.put(`${multilingualSettingsResource}`, {
      section,
      ...payload,
    })
  },
}
